import React from 'react'
import ArrowLink from './ArrowLink'
import MessageNotification from './MessageNotification';
import TransactionCard from './TransactionCard';
import CountdownTimer from './CountdownTimer';
import FloatingIcon from './FloatingIcon'
import ActionButton from './ActionButton';

function Center() {
  return (
    <div>      
      <ArrowLink/>      
      <MessageNotification/>
      <TransactionCard/>
      <CountdownTimer/>
      <FloatingIcon/>
      <ActionButton/>
    </div>
  )
}

export default Center